export default "__VITE_ASSET__C8aCrKgn__"